<div class="hdmi-title">
  <h1 *ngIf="hdmiConnected; else notConnected">
    {{ 'PAGES.HDMI.CONNECTED' | translate: { hdmiPort: hdmiPort } }}
  </h1>
  <ng-template #notConnected>
    <h1>{{ 'PAGES.HDMI.NOT_CONNECTED' | translate: { hdmiPort: hdmiPort } }}</h1>
    <h3>{{ 'PAGES.HDMI.CONNECTION_MESSAGE' | translate: { hdmiPort: hdmiPort } }}</h3>
    <h3>{{ 'PAGES.HDMI.TRY_AGAIN_MESSAGE' | translate: { requestTime: requestTime } }}</h3>
  </ng-template>
  <button type="button" class="htv-selectable htv-button" (click)="goBack()">
    {{ 'BACK' | translate }}
  </button>
</div>
